import qs from 'qs';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useApi, useAuth } from '../../hooks';
import type {
  AppointmentProviderCategory,
  AppointmentProviderType,
  AppointmentType,
} from '../../models/appointment-type';

type Params = {
  enabled?: boolean;
  provider_category?: AppointmentProviderCategory[];
  provider_type?: AppointmentProviderType;
};

export const useAppointmentTypes = ({
  enabled: enabledFilter,
  provider_category,
  provider_type,
}: Params = {}) => {
  const { patient: userId } = useParams();
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const queryStr = qs.stringify(
    { enabled: enabledFilter, provider_category, provider_type },
    { skipNulls: true, addQueryPrefix: true }
  );

  const fetchAppointmentTypes = async (): Promise<AppointmentType[]> => {
    return api({
      route: `/private/user/appointments/appointment-types${queryStr}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    });
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    AppointmentType[],
    Error
  >({
    queryKey: ['appointment-types', userToken, userId, queryStr],
    queryFn: fetchAppointmentTypes,
    enabled: isAuthenticated && !loading && !!userToken && !!userId,
    refetchOnWindowFocus: false,
    refetchInterval: 60000,
  });

  return {
    appointmentTypes: data,
    isInitialLoading,
    isLoading,
    isError,
  };
};
